import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/manga";
import { getCategory } from "@/utils/manga";
import MangaGrid from "@/components/feature/MangaGrid";

export default function FreeZone() {
  const free = mangaList.filter((m) => m.isFree);
  const top6 = free.slice(0, 6);
  const total = free.length;

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20" id="free">
      <div className="rounded-2xl bg-gradient-to-r from-primary-500 to-secondary-500 px-5 py-8 md:px-8 md:py-10">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
          <div>
            <span className="inline-flex items-center gap-1 rounded-full bg-background-50/20 px-3 py-1 text-xs font-medium text-background-50">
              <i className="ri-vip-crown-2-line" /> 免费专区
            </span>
            <h2 className="mt-2 font-heading text-2xl text-background-50 md:text-3xl">
              {total}+ 部漫画免费看，追更不再心疼
            </h2>
            <p className="mt-1 text-sm text-background-50/90">
              精选高人气免费漫画，恋爱、热血、悬疑全都有，零门槛畅读。
            </p>
          </div>
          <Link
            to="/free"
            className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-background-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
          >
            进入免费专区 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>

      <div className="mt-6 flex flex-wrap gap-2">
        {[...new Set(free.map((m) => getCategory(m.category).name))].slice(0, 8).map((name) => (
          <span key={name} className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
            {name}
          </span>
        ))}
      </div>
      <div className="mt-6">
        <MangaGrid items={top6} cols={6} />
      </div>
    </section>
  );
}